import { inject, Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { environment } from 'libs/core/src/lib/environments/environment';
import { IAuthService } from 'libs/core/src/lib/services/auth.service';
import { HttpClient } from '@angular/common/http';
import {
  ILoginRequest,
  ILoginResponse,
  IResetPassword,
  IResetPasswordOtp,
  ISuccessulResponse,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerAuthService implements IAuthService {
  private httpClient = inject(HttpClient);
  env = environment;

  login(login: Partial<ILoginRequest>): Observable<ILoginResponse> {
    return this.httpClient.post<ILoginResponse>(
      `${baseUrl()}/auth/partners/login`,
      {
        ...login,
        partnerId: this.env.partnerId,
        insurerId: this.env.insurerId,
        // On a broker's domain: only that broker's partners (one email may cover several of them)
        intermediaryId: this.env.intermediaryId,
      },
    );
  }
  requestPasswordResetOtp(
    login: IResetPasswordOtp,
  ): Observable<ISuccessulResponse> {
    return this.httpClient.post<ISuccessulResponse>(
      `${baseUrl()}/auth/password-reset/partners/otp`,
      {
        ...login,
        partnerId: this.env.partnerId,
        insurerId: this.env.insurerId,
        intermediaryId: this.env.intermediaryId,
      },
    );
  }

  resetPassword(login: IResetPassword): Observable<ISuccessulResponse> {
    return this.httpClient.post<ISuccessulResponse>(
      `${baseUrl()}/auth/password-reset/partners`,
      {
        ...login,
        partnerId: this.env.partnerId,
        insurerId: this.env.insurerId,
        intermediaryId: this.env.intermediaryId,
      },
    );
  }
}
